import { Injectable, Optional } from '@angular/core';

import { waiterLockService } from '@app/modules/waiter-lock.service';

// Consumidor de escaneos de CÓDIGO DE BARRAS. Las teclas del lector (keyboard
// wedge) las captura y clasifica keyboardWedgeService (modules/common/keyboard-
// wedge.ts), que entrega aquí los códigos que no son pulseras RFID vía Inject().
// Este servicio solo aporta el callback del carrito y las reglas de contexto.
@Injectable()
export class barcodeService {
    private _enabled = false;
    private _onScan: ((code: string) => void) = null;
    private _focusSink: HTMLElement = null;

    constructor(@Optional() private waiterLock: waiterLockService) {
        // nothing to do
    }

    get IsEnabled(){
        return this._enabled;
    }

    enable(callback: (code: string) => void){
        if (this._enabled){
            return;     // already enabled, ignore
        }

        this._onScan = callback;

        // Off-screen focusable element. After every recognised scan that
        // was caught by the toolbar searchbar we park the focus here so
        // the cursor doesn't land on whatever random button/icon is next
        // in tab order — that was making the page jump on every Enter.
        if (!this._focusSink){
            let _sink = document.createElement('div');
            _sink.tabIndex = -1;
            _sink.setAttribute('aria-hidden', 'true');
            _sink.style.position = 'fixed';
            _sink.style.left = '-9999px';
            _sink.style.top = '0';
            _sink.style.width = '1px';
            _sink.style.height = '1px';
            _sink.style.opacity = '0';
            _sink.style.pointerEvents = 'none';
            document.body.appendChild(_sink);
            this._focusSink = _sink;
        }

        this._enabled = true;
    }

    disable(){
        if (!this._enabled){
            return;
        }

        this._onScan = null;
        this._enabled = false;

        if (this._focusSink){
            if (this._focusSink.parentNode){
                this._focusSink.parentNode.removeChild(this._focusSink);
            }
            this._focusSink = null;
        }
    }

    // Código completo leído por el lector (lo entrega keyboardWedgeService).
    Inject(code: string){
        if (!this._enabled || !this._onScan || !code){
            return;
        }

        // BLOQUEO por camarero: el modal (de bloqueo O de PIN manual/captura) es solo
        // un overlay y no detiene los listeners a nivel de documento. Sin esto, un
        // escaneo del lector seguiría llegando a OnProduct/OnDirect y mutaría la
        // comanda durante la entrada de PIN.
        if (this.waiterLock && (this.waiterLock.IsLocked || this.waiterLock.IsPinModalOpen)){
            return;
        }

        // Park focus on the offscreen sink so the next scan starts from a
        // known neutral element instead of jumping around buttons via the
        // tab order.
        if (this._focusSink){
            this._focusSink.focus({ preventScroll: true });
        }

        this._onScan(code);
    }
}
